import { render, staticRenderFns } from "./BackButton.vue?vue&type=template&id=4d3284a9"
import script from "./BackButton.vue?vue&type=script&lang=js"
export * from "./BackButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d3284a9')) {
      api.createRecord('4d3284a9', component.options)
    } else {
      api.reload('4d3284a9', component.options)
    }
    module.hot.accept("./BackButton.vue?vue&type=template&id=4d3284a9", function () {
      api.rerender('4d3284a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BackButton.vue"
export default component.exports